<template>
  <van-popup
    v-model="visible"
    position="bottom"
    :style="{ height: '90vh' }"
    closeable
  >
    <div class="dialog-container">
      <div class="dialog-title">编辑物料</div>

      <van-form ref="form" @submit="onSubmit" class="form-wrapper">
        <!-- 产品标题 -->
        <van-field
          v-model="formData.productTitle"
          name="productTitle"
          label="产品标题"
          placeholder="请输入产品标题"
          :rules="[{ required: true, message: '产品标题不能为空' }]"
        />

        <!-- 物料唯一ID -->
        <van-field
          v-model="formData.materielUniqueId"
          name="materielUniqueId"
          label="物料ID"
          placeholder="物料ID"
          disabled
        />

        <!-- 产品信息 -->
        <van-field
          v-model="formData.productInfo"
          name="productInfo"
          label="产品信息"
          type="textarea"
          placeholder="请输入产品信息"
          rows="3"
          :rules="[{ required: true, message: '产品信息不能为空' }]"
        />

        <!-- 采购人 -->
        <van-field
          v-model="formData.purchaser"
          name="purchaser"
          label="采购人"
          placeholder="请输入采购人名称"
          :rules="[{ required: true, message: '采购人不能为空' }]"
        />

        <!-- 供货商 -->
        <van-field
          v-model="formData.supplier"
          name="supplier"
          label="供货商"
          placeholder="请输入供货商名称"
          :rules="[{ required: true, message: '供货商不能为空' }]"
        />

        <!-- 联系电话 -->
        <van-field
          v-model="formData.contactPhone"
          name="contactPhone"
          label="联系电话"
          type="tel"
          placeholder="请输入联系电话"
          :rules="[
            { required: true, message: '联系电话不能为空' },
            { pattern: /^[\d-+\s()]*$/, message: '电话号码格式不正确' }
          ]"
        />

        <!-- 购买链接 -->
        <van-field
          v-model="formData.purchaseLink"
          name="purchaseLink"
          label="购买链接"
          placeholder="请输入购买链接（可选）"
          type="url"
        />

        <!-- 购买价格 -->
        <van-field
          v-model.number="formData.purchasePrice"
          name="purchasePrice"
          label="参考价格"
          type="number"
          placeholder="请输入参考价格（可选）"
        />

        <!-- 产品图片 -->
        <div class="image-upload-wrapper">
          <div class="field-label">产品图片</div>
          <van-uploader
            v-model="fileList"
            :after-read="handleImageUpload"
            accept="image/*"
            multiple
            max-count="3"
          />
        </div>

        <!-- 提交按钮 -->
        <div class="form-footer">
          <van-button
            block
            type="primary"
            native-type="submit"
            :loading="loading"
          >
            更新
          </van-button>
          <van-button
            block
            @click="visible = false"
            style="margin-top: 10px"
          >
            取消
          </van-button>
        </div>
      </van-form>
    </div>
  </van-popup>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      loading: false,
      fileList: [],
      formData: {
        id: null,
        productTitle: '',
        materielUniqueId: '',
        productInfo: '',
        purchaser: '',
        supplier: '',
        contactPhone: '',
        purchaseLink: '',
        purchasePrice: null,
        productImage: '',
      },
    };
  },

  methods: {
    open(item) {
      this.visible = true;
      this.formData = { ...item };
      if (item.productImage) {
        this.fileList = [
          {
            url: item.productImage,
            isImage: true,
          },
        ];
      } else {
        this.fileList = [];
      }
    },

    handleImageUpload(file) {
      if (file.content) {
        this.formData.productImage = file.content;
      } else if (file.file) {
        this.uploadImageToServer(file.file);
      }
      this.$toast('图片已更新');
    },

    uploadImageToServer(file) {
      const formData = new FormData();
      formData.append('file', file);

      this.axios
        .post('/Materiel/UploadImage', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          if (response.data.code === 101) {
            this.formData.productImage = response.data.data;
          }
        })
        .catch(() => {
          this.$toast.fail('图片上传失败');
        });
    },

    onSubmit() {
      this.$refs.form.validate().then(() => {
        this.loading = true;

        this.axios
          .post('/Materiel/Update', this.formData)
          .then((response) => {
            this.loading = false;
            if (response.data.code === 101) {
              this.$toast.success('更新成功');
              this.visible = false;
              this.$emit('success');
            } else {
              this.$toast.fail(response.data.msg || '更新失败');
            }
          })
          .catch(() => {
            this.loading = false;
            this.$toast.fail('更新失败');
          });
      });
    },
  },
};
</script>

<style scoped>
.dialog-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.dialog-title {
  padding: 16px;
  font-size: 16px;
  font-weight: bold;
  border-bottom: 1px solid #f0f0f0;
}

.form-wrapper {
  flex: 1;
  overflow-y: auto;
  padding: 0 16px;
}

.image-upload-wrapper {
  padding: 16px 0;
  border-bottom: 1px solid #ebedf0;
}

.field-label {
  font-size: 14px;
  color: #333;
  margin-bottom: 8px;
  font-weight: 500;
}

.form-footer {
  padding: 16px;
  border-top: 1px solid #f0f0f0;
  background: #fff;
}
</style>
